function addUpsellToCart(thisButton) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-items');
    var submitButton = thisButton;
    // var form = document.querySelector('[id^="product-upsell-template-' + thisButton.dataset.formid + '--"]');
    var form = thisButton.closest('form');
    if (document.querySelector('cart-drawer') || document.querySelector('cart-items')) submitButton.setAttribute('aria-haspopup', 'dialog');

    if (submitButton.getAttribute('aria-disabled') === 'true') return;
 
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form); 
    if (thisButton.dataset.cartType != 'page') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        // console.log(formData + ' ' + window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                submitButton.setAttribute('aria-disabled', true);
                submitButton.querySelector('span').classList.add('hidden');
                return;
            }
            thisButton.error = false;
          if (window.location.pathname.includes('/cart')) {
          location.reload();
          } else {
          cart.renderContents(response);
          }
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            submitButton.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
}



function changeVariantEvent(thisVariant) {
    thisVariant.closest('.product-upsell-template').querySelector('#formUpsellId').value = thisVariant.value
}